import type { PropsWithChildren } from 'react';

import { Button, Modal, Spin, type ModalProps } from 'antd';

import styles from './ConfirmModal.module.scss';

interface IProp extends ModalProps {
  isModalOpen: boolean;
  handleCancel: VoidFunction;
  handleConfirm: VoidFunction;
  title: string;
  description?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  shouldDisableElement?: boolean;
}

export const ConfirmModal = ({
  width = 600,
  isModalOpen,
  handleCancel,
  handleConfirm,
  title,
  description,
  confirmButtonText = 'Подтвердить',
  cancelButtonText = 'Отмена',
  shouldDisableElement = false,
  children,
}: PropsWithChildren<IProp>) => (
  <Modal
    width={width}
    open={isModalOpen}
    onCancel={handleCancel}
    footer={null}
    centered
  >
    <Spin spinning={shouldDisableElement}>
      <div className={styles.wrapper}>
        <p className={styles.title}>{title}</p>
        {description && <p className={styles.description}>{description}</p>}
        {children}
        <div className={styles['buttons-wrapper']}>
          <Button
            size="large"
            onClick={handleCancel}
            danger
            className={styles.button}
          >
            {cancelButtonText}
          </Button>
          <Button
            size="large"
            onClick={handleConfirm}
            className={styles.button}
            type="primary"
            disabled={shouldDisableElement}
          >
            {confirmButtonText}
          </Button>
        </div>
      </div>
    </Spin>
  </Modal>
);
